"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZoningsMetricsService = exports.ZONE_METRICS_CATEGORIES_NAME = void 0;
const lodash_1 = require("lodash");
const metrics_service_1 = require("./metrics-service");
const global_1 = require("../global");
exports.ZONE_METRICS_CATEGORIES_NAME = {
    [global_1.ZoneMetricCategory.Attractiveness]: 'METRIC.ZONING.TYPE.ATTRACTIVENESS',
    [global_1.ZoneMetricCategory.ROI]: 'METRIC.ZONING.TYPE.ROI',
    [global_1.ZoneMetricCategory.Performance]: 'METRIC.ZONING.TYPE.PERFORMANCE',
    [global_1.ZoneMetricCategory.Interaction]: 'METRIC.ZONING.TYPE.INTERACTION',
    [global_1.ZoneMetricCategory.Heatmap]: 'METRIC.ZONING.TYPE.HEATMAP',
};
class ZoningsMetricsService {
    static getCategorizedMetrics(filters) {
        const metricsWithCategory = metrics_service_1.MetricsList.getZoneMetrics(filters).filter((metric) => !!metric.category);
        const groupedMetrics = (0, lodash_1.groupBy)(metricsWithCategory, 'category');
        return Object.entries(groupedMetrics).reduce((acc, [categoryId, metrics]) => {
            return [
                ...acc,
                {
                    categoryName: exports.ZONE_METRICS_CATEGORIES_NAME[categoryId],
                    items: metrics,
                },
            ];
        }, []);
    }
}
exports.ZoningsMetricsService = ZoningsMetricsService;
//# sourceMappingURL=zonings-metric-service.js.map